import Notifications from "@kyvg/vue3-notification";
import {
  defineNuxtPlugin
} from "#imports";
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Notifications);
});
